import CityBackground from './CityBackground';
import SectionHeader from '../components/SectionHeader';
import ProjectCard from '../components/ProjectCard';
import AppDemoCard from '../components/AppDemoCard';
import { appDemos, projects } from '../data/portfolio';
import styles from './Projects.module.css';

function Projects() {
  return (
    <div className={styles.projects}>
      <div className={styles.backgroundSvg}>
        <CityBackground />
      </div>
      <SectionHeader 
        title="Projects" 
        subtitle="From systems integration to applications you can explore"
      />

      <section className={styles.demoSection} aria-labelledby="app-demos-title">
        <div className={styles.sectionIntro}>
          <div>
            <h2 id="app-demos-title" className={styles.sectionTitle}>Application demos</h2>
            <p className={styles.sectionDescription}>
              Explore the apps I'm building and the websites I've shipped.
            </p>
          </div>
          <span className={styles.sectionLabel}>Web apps & websites</span>
        </div>
        <div className={styles.demoGrid}>
          {appDemos.map((demo, index) => (
            <AppDemoCard key={demo.id} demo={demo} index={index} />
          ))}
        </div>
        <p className={styles.demoNote}>
          Projects in development are evolving, with more features and refinements on the way.
        </p>
      </section>

      <section aria-labelledby="engineering-projects-title">
        <div className={styles.sectionIntro}>
          <div>
            <h2 id="engineering-projects-title" className={styles.sectionTitle}>Engineering projects</h2>
            <p className={styles.sectionDescription}>
              Selected work in distributed systems, software development and research.
            </p>
          </div>
        </div>
        <div className={styles.projectGrid}>
          {projects.map(project => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </section>

      <div className={styles.moreProjects}>
        <p>
          Follow my work on{' '}
          <a href="https://github.com/JoaoLopes017" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>{' '}
          for more projects and ongoing development.
        </p>
      </div>
    </div>
  );
}

export default Projects;
